import * as React from 'react';
import { useUnitDetailBreadcrumbQuery } from '../../../types/generated-types';

export function UnitDetailBreadcrumb({ id }: { id?: string }) {
  const { data } = useUnitDetailBreadcrumbQuery({
    variables: { _id: id || '' },
  });
  return <span>{data?.unitById?.name || 'un-named unit'}</span>;
}
